/* ==========================================================================
   pdp-order-ack.js — The Park Wholesale
   Products flagged with custom.show_warning_confirmation_popup: the buyer ticks
   "I've read the order guidelines" before adding to cart (snippets/product-info.liquid).
   - Add to cart (main button, or the sticky bar, which presses the main one) without the tick:
     nothing is added; an inline message shows (announced) and focus moves to the checkbox.
   - Ticking it clears the message. The button is never disabled.
   - Long guidelines: 3 lines + "Read more" / "Read less" — only when the text is longer than 3
     lines (counted in lines, not pixels). Screen readers hear "Read more order guidelines".
   Loaded only on those products.
   ========================================================================== */
(function () {
  if (window.__pdpOrderAck) return;
  window.__pdpOrderAck = true;

  function parts(form) {
    var scope = form.closest('.prod-info, .product-single, [id^="ProductSection-"]') || document;
    return {
      box: scope.querySelector('[data-pdp-ack-box]'),
      error: scope.querySelector('[data-pdp-ack-error]'),
      wrap: scope.querySelector('[data-pdp-ack]')
    };
  }

  function showError(p) {
    p.error.hidden = false;
    p.error.setAttribute('role', 'alert'); // announced once, when it appears
    p.box.setAttribute('aria-invalid', 'true');
    p.wrap.classList.add('is-error');
    p.box.focus({ preventScroll: true });
    p.wrap.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  }

  function clearError(p) {
    p.error.hidden = true;
    p.error.removeAttribute('role');
    p.box.removeAttribute('aria-invalid');
    p.wrap.classList.remove('is-error');
  }

  // Products that also need a logo upload (Upload-Lift): the upload is checked first. While no file
  // is added, the add is stopped but the checkbox message waits, so the buyer hears one error at a
  // time (the upload's own message is announced by the app's script).
  function uploadMissing() {
    var w = document.querySelector('.cl-upload--wrapper');
    return !!w && w.querySelectorAll('.filepond--item').length === 0;
  }

  // Capture phase: runs before the theme's AJAX add-to-cart handler on the form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var p = parts(form);
    if (!p.box || p.box.checked) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (uploadMissing()) return; // upload error first; this one comes after a file is added
    showError(p);
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-pdp-ack-box]')) return;
    var wrap = e.target.closest('[data-pdp-ack]');
    if (!wrap || !e.target.checked) return;
    clearError({ box: e.target, error: wrap.querySelector('[data-pdp-ack-error]'), wrap: wrap });
  });

  // Long guidelines: clamp to 3 lines + "Read more", only when there really are more than 3 lines
  function lineHeight(el) {
    var cs = window.getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    return isNaN(lh) ? parseFloat(cs.fontSize) * 1.4 : lh; // "normal" → ~1.4 × font size
  }
  function isLong(text) {
    var wasOpen = text.classList.contains('is-open');
    if (wasOpen) text.classList.remove('is-open'); // measure in the clamped state
    var full = text.scrollHeight;
    if (wasOpen) text.classList.add('is-open');
    // more than 3 lines = at least half a line beyond 3 (margins / rounding don't count)
    return full > lineHeight(text) * 3.5;
  }
  function setupMore() {
    document.querySelectorAll('[data-pdp-ack-text]').forEach(function (text) {
      var btn = text.parentNode.querySelector('[data-pdp-ack-more]');
      if (!btn) return;
      var label = btn.querySelector('[data-pdp-ack-more-label]') || btn;
      var long = isLong(text);
      btn.hidden = !long;
      if (!long) { // short text: show it all, no button
        text.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        if (!btn.__bound) text.classList.remove('is-open'); // first time: start clamped
        var open = text.classList.contains('is-open');  // keep label + state in step
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? 'Read less' : 'Read more';
      }
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var open = text.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }

  function start() {
    setupMore();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(setupMore, 150); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();